import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {WLUtils} from '../utils/WLUtils.js';
import {vec3} from 'gl-matrix';
import {Statistics} from './statistics.js';
import {StatNames} from '../enums/StatNames.js';

const minY = -0.1;
const maxY = 0.75;
const currentPos = vec3.create();

export class CreditsScene extends Component {
    static TypeName = 'credits-scene';

    @property.float(0.05)
    animationSpeed = 0.05;

    // Singleton
    private static _instance: CreditsScene;
    static get instance(): CreditsScene {
        return CreditsScene._instance;
    }

    init() {
        this.active = false;
        WLUtils.setActive(this.object, false);
        if (CreditsScene._instance) {
            console.error('There can only be one instance of CreditsScene Component');
        }
        CreditsScene._instance = this;
    }
    start(): void {
        this._resetStartPosition();
    }

    show() {
        WLUtils.setActive(this.object, true);
        this._resetStartPosition();
    }

    hide() {
        WLUtils.setActive(this.object, false);
    }
    update(dt: number) {
        this._positionUpdate(dt);
    }

    private _resetStartPosition() {
        this.object.getPositionLocal(currentPos);
        this.object.setPositionLocal([currentPos[0], minY, currentPos[2]]);
    }

    private _positionUpdate(dt: number) {
        this.object.getPositionLocal(currentPos);
        if (currentPos[1] < maxY) {
            currentPos[1] += this.animationSpeed * dt;
            this.object.setPositionLocal(currentPos);
        } else {
            Statistics.instance.record(StatNames.CreditsWatched, 1);
            this.object.setPositionLocal([currentPos[0], minY, currentPos[2]]);
        }
    }
}
